/**
 * Strip the canonical `<13-digit-timestamp>-<uuid>-` prefix from a
 * storage object key and return the human-uploaded filename.
 *
 * Blob-storage object keys are prefixed with
 * `<13-digit-timestamp>-<uuid>-<originalFileName>` for uniqueness. Most
 * UI surfaces, processors, and helper prompts want the tail (the human-
 * uploaded filename) without the timestamp/UUID noise.
 */
export const FILE_KEY_PREFIX_RE =
  /^\d{13}-[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}-/i;

export function displayFileNameFromObjectKey(objectKey: string | null | undefined): string {
  if (!objectKey) return "";
  const tail = objectKey.split("/").pop() ?? "";
  return tail.replace(FILE_KEY_PREFIX_RE, "");
}
